import * as React from 'react';

const LogoutIcon = ({
  height = 24,
  width = 24,
}: {
  height: number;
  width: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 18.998V7.50298C11 6.81298 10.645 6.17198 10.06 5.80698L6.06 3.30698C4.728 2.47498 3 3.43198 3 5.00298V16.497C3 17.187 3.355 17.828 3.94 18.193L7.94 20.693C9.272 21.526 11 20.568 11 18.998Z"
      stroke="#3C3C3C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 11H15"
      stroke="#3C3C3C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 9L15 11L17 13"
      stroke="#3C3C3C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 19H15C16.105 19 17 18.105 17 17V16"
      stroke="#3C3C3C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 6V5C17 3.895 16.105 3 15 3H5"
      stroke="#3C3C3C"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default LogoutIcon;
